export default {
  title: {
    en: 'Want to get it next month instead?',
  },
  text: {
    en: `
      You’ve chosen a <span class="text-bold">Limited Edition</span> product – once these items are gone,
      they might not be restocked. Schedule it for your next order to ensure it’s yours.
    `,
  },
  confirmButton: {
    en: 'I want it next month',
  },
  cancelButton: {
    en: 'Just leave it as it is',
  },
}
